
import React, { useState } from 'react';
import { Card, Button, Input } from '../../components';
import { BsFillInfoSquareFill } from 'react-icons/bs';
import BottomNav from '../../components/BottomNav/Boomnav';
import './ActivationPage.css';

const ActivationPage = ({ onNavigate }) => {
  const [codigo, setCodigo] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [carregando, setCarregando] = useState(false);

  // Função para aplicar máscara XXXX-XXXX-XXXX
  function handleCodigoChange(e) {
    let value = e.target.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    value = value.slice(0, 12);
    let masked = '';
    for (let i = 0; i < value.length; i++) {
      masked += value[i];
      if ((i + 1) % 4 === 0 && i < 11) masked += '-';
    }
    setCodigo(masked);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setMensagem("");
    setCarregando(true);

    // Recupera usuário logado pelo localStorage 'usuarioLogado'
    const usuarioLogado = JSON.parse(localStorage.getItem('usuarioLogado'));
    if (!usuarioLogado || !usuarioLogado.email) {
      setMensagem("Usuário não autenticado.");
      setCarregando(false);
      return;
    }

    // Recupera lista de usuários
    const usuarios = JSON.parse(localStorage.getItem('prisma_users') || '[]');
    const usuarioIndex = usuarios.findIndex(u => u.email === usuarioLogado.email);
    if (usuarioIndex === -1) {
      setMensagem("Usuário não encontrado.");
      setCarregando(false);
      return;
    }
    const usuario = usuarios[usuarioIndex];

    const codigoFormatado = codigo.trim();
    // Códigos protegidos por variáveis de ambiente CRA (REACT_APP_)
    const CODIGO_1000 = process.env.REACT_APP_CODIGO_1000;
    const CODIGO_100 = process.env.REACT_APP_CODIGO_100;
    const CODIGO_200 = process.env.REACT_APP_CODIGO_200;
    const CODIGO_500 = process.env.REACT_APP_CODIGO_500;
    let valorAdicional = 0;
    if (codigoFormatado === CODIGO_1000) {
      valorAdicional = 1000;
    } else if (codigoFormatado === CODIGO_100) {
      valorAdicional = 100;
    } else if (codigoFormatado === CODIGO_200) {
      valorAdicional = 200;
    } else if (codigoFormatado === CODIGO_500) {
      valorAdicional = 500;
    } else {
      setMensagem("Código inválido.");
      setCarregando(false);
      return;
    }

    // Permitir ativação se saldo for 0 OU código anterior já rodado (codigoAtivo === false)
    if ((usuario.saldoInicial || 0) !== 0 && usuario.codigoAtivo) {
      setMensagem("Aguarde até que a operação atual tenha sido finalizada.");
      setCarregando(false);
      return;
    }
    // Verifica se o código já foi usado
    if (usuario.codigosUsados && usuario.codigosUsados.includes(codigoFormatado)) {
      setMensagem("Este código já foi utilizado, solicite um novo código.");
      setCarregando(false);
      return;
    }
    // Adiciona saldo conforme o código
    const novoSaldo = (usuario.saldoInicial || 0) + valorAdicional;
    // Marca o código como usado e ativa o código para liberar simulação
    const novosCodigosUsados = usuario.codigosUsados ? [...usuario.codigosUsados, codigoFormatado] : [codigoFormatado];
    const novoSaldoDisponivel = (usuario.saldoDisponivel || usuario.saldoInicial || 0) + valorAdicional;
    const usuarioAtualizado = {
      ...usuario,
      saldoInicial: novoSaldo,
      saldoDisponivel: novoSaldoDisponivel,
      codigoAtivo: true,
      codigosUsados: novosCodigosUsados
    };
    // Atualiza também no prisma_users
    usuarios[usuarioIndex] = usuarioAtualizado;
    usuarios[usuarioIndex] = usuarioAtualizado;
    localStorage.setItem('prisma_users', JSON.stringify(usuarios));
    // Atualiza o usuário logado com novo saldo
    localStorage.setItem('usuarioLogado', JSON.stringify(usuarioAtualizado));
    // Salva o saldo inicial ativado para o Bot
    localStorage.setItem('saldoInicialBot', novoSaldo);
    setMensagem(`Código ativado com sucesso! $${valorAdicional} adicionados ao seu saldo.`);
    setCarregando(false);
    // Redireciona para o bot somente após ativação bem-sucedida
    setTimeout(() => {
      if (onNavigate) onNavigate('bot');
    }, 1000);
  };

  const [active, setActive] = useState('activation');
  const handleNavChange = (id) => {
    setActive(id);
    if (onNavigate) onNavigate(id);
  };

  return (
    <div className="activation-page" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBottom: 90 }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <Card style={{ background: '#232b36', borderRadius: 18, boxShadow: '0 4px 32px 0 rgba(2, 6, 23, 0.25)', padding: 36, margin: '0 auto' }}>
          <h2 className="activation-title" style={{ textAlign: 'center', fontSize: 28, fontWeight: 800, marginBottom: 8 }}>Ativar Código</h2>
          <p className="activation-subtitle" style={{ textAlign: 'center', marginBottom: 24, fontSize: 15 }}>Insira seu Código de Ativação para Creditar Saldo</p>
          <div style={{ fontWeight: 600, marginBottom: 8, color: '#fff' }}>Adicionar Fundos</div>
          <form onSubmit={handleSubmit}>
            <Input
              placeholder="XXXX-XXXX-XXXX"
              value={codigo}
              onChange={handleCodigoChange}
              className="code-input"
              style={{ marginBottom: 18, background: '#181e27', color: '#fff', border: '1.5px solid #232b36', fontSize: 18, textAlign: 'center', fontWeight: 700, letterSpacing: 2, height: 56 }}
              disabled={carregando}
            />
            <Button
              style={{ background: '#00c689', color: '#fff', fontWeight: 700, fontSize: 18, marginBottom: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
              type="submit"
              disabled={carregando}
            >
              <span role="img" aria-label="key">🔑</span> Ativar Código
            </Button>
          </form>
          {mensagem && (
            <div className="error-message" style={{ background: mensagem.includes('sucesso') ? '#232b36' : '#2d2323', color: mensagem.includes('sucesso') ? '#00c689' : '#ff6b6b', border: `1px solid ${mensagem.includes('sucesso') ? '#00c689' : '#ff6b6b'}`, borderRadius: 8, padding: 10, marginBottom: 12, textAlign: 'center' }}>
              {mensagem}
            </div>
          )}
          <Card style={{ background: '#b5bfc9', color: '#232b36', border: '1.5px solid #b5bfc9', borderRadius: 12, marginTop: 10, marginBottom: 0, padding: 16 }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 6 }}>
              <span style={{ fontSize: 20, color: '#2059a8', marginTop: 2 }}><BsFillInfoSquareFill /></span>
              <div>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 2 }}>Como funciona?</div>
                <div style={{ fontSize: 13, color: '#232b36' }}>
                  Insira o código de ativação fornecido. Após a ativação, os bots associados ao código serão liberados para sua conta.
                </div>
              </div>
            </div>
          </Card>
        </Card>
      </div>
      <BottomNav active={active} onChange={handleNavChange} />
    </div>
  );
};

export default ActivationPage;